<main class="right-container-width">
    <h1>Sie haben erfolgreich ein Abo gebucht!</h1>
    <p>Sie können nun Ihr Produkt hinzufügen und listen.</p>
    <div>
        <button [routerLink]="['']" matButton="elevated" color="warn">
            Zurück zur Startseite
        </button>
        <button matButton="elevated" class="green-confirm" [routerLink]="['/organisations/' +
                        organisationService.activeItem.organisationId +
                        '/firstProduct/']">
            Weiter
        </button>
    </div>
</main>